import { useEffect } from 'preact/hooks';
import * as S from '../app/state';
import { t } from '../i18n';
import { Btn } from './common';

/** In-app confirmation instead of the browser's dialog: styled, keyboard friendly, never blocks the tab. */
export function ConfirmModal() {
  const req = S.confirmReq.value;
  useEffect(() => {
    if (!req) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        S.answerConfirm(false);
      } else if (e.key === 'Enter') {
        e.stopPropagation();
        S.answerConfirm(true);
      }
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [req]);
  if (!req) return null;
  return (
    <div class="modal confirm" onClick={() => S.answerConfirm(false)}>
      <div class="card narrow panel col pop" onClick={(e) => e.stopPropagation()}>
        {req.title && <h2>{req.title}</h2>}
        <div style={{ lineHeight: 1.45 }}>{req.text}</div>
        <div class="row" style={{ justifyContent: 'flex-end', marginTop: 6 }}>
          <Btn onClick={() => S.answerConfirm(false)}>{req.cancel ?? t('btn.cancel')}</Btn>
          <Btn primary danger={req.danger} onClick={() => S.answerConfirm(true)}>
            {req.ok ?? t('btn.continue')}
          </Btn>
        </div>
      </div>
    </div>
  );
}
